/* istanbul ignore file */
import React from 'react'
import interceptedAxios from '../../../utils/interceptedAxios'

export class viewGatewayService {
  public static async viewGateway (gatewayId: string, assetId: string): Promise<any> {
    const GatewayListUrl = `/assetrest/api/v2/udp/tiq/assets/${gatewayId}?assetId=${assetId}`
    return await interceptedAxios.get(GatewayListUrl)
  }

  render (): any {
    return (
      <></>
    )
  }
}
